import { render } from "./IconOrphan.vue?vue&type=template&id=7e8b5bc3"
import script from "./IconOrphan.vue?vue&type=script&lang=ts"
export * from "./IconOrphan.vue?vue&type=script&lang=ts"
script.render = render

export default script